/* eslint-disable tailwindcss/no-arbitrary-value */
import { getNationalityFlagImageSrc } from 'utils/helpers/travelInsurance';

type FlagImageProps = {
  countryCode: string;
  countryName: string;
};

export function FlagImage({ countryCode, countryName }: FlagImageProps) {
  return (
    <img
      alt={countryName}
      className="h-4 w-[22px] rounded border border-gray-300 object-cover"
      src={getNationalityFlagImageSrc('h20', countryCode)}
    />
  );
}
